<template>
  <div v-if="isLoading">
    <ShimmerProductGallery />
  </div>
  <div v-else-if="items" class="gallery">
    <!-- Multiple Media -->
    <ul
      v-if="items.length > 1"
      class="flex px-4 space-x-4 overflow-auto flex-nowrap rtl:space-x-reverse lg:grid lg:grid-cols-2 lg:flex-wrap lg:gap-4 lg:space-x-0 lg:px-0"
    >
      <li
        v-for="(item, index) in items"
        :key="`media-${index}`"
        class="flex-shrink-0 w-80 h-80 lg:w-auto lg:h-auto lg:aspect-w-1 lg:aspect-h-1"
      >
        <StoreProductMedia
          class="w-full h-full cursor-pointer"
          :value="[item]"
          size="500x500"
          play-button
          @click="$nuxt.callHook('modal-open', 'modal-media', item)"
        />
      </li>
    </ul>

    <!-- Single Media -->
    <div v-else class="px-4 cursor-pointer lg:px-0">
      <StoreProductMedia
        size="500x500"
        class="w-full"
        play-button
        :value="items"
        @click="
          items && items[0]
            ? $nuxt.callHook('modal-open', 'modal-media', items[0])
            : null
        "
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: { type: Array, default: () => [] },
    isLoading: Boolean,
  },
};
</script>

<style>
.gallery * {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
</style>
